import { Para, Stack } from 'ui-components';

type Props = { title: string; children: React.ReactNode };

export default function Action({ title, children }: Props): React.ReactElement {
  return (
    <Stack gap={2} className="flex-col items-center lg:flex-row lg:items-center">
      <Para className="whitespace-nowrap font-aribaubold">{title}:</Para>

      {children}
    </Stack>
  );
}
